module.exports = __webpack_public_path__ + "img/seattle.1a1a7d9b.jpg";